export default __webpack_public_path__ + "static/media/idea-web-1.d0563702.png";